import React from 'react';
import { Heading3, Margin, P } from '@ovotech/element-v4';
import styled from 'styled-components';

const StyledHeading3 = styled(Heading3)`
  font-size: 20px;
  font-weight: 700;
  color: #000;
  margin-bottom: 8px;
`;

export const NeedToKnowStep2: React.FC = () => (
  <Margin top={6}>
    <StyledHeading3>Crediting</StyledHeading3>
    <Margin bottom={6}>
      <P>
        Check the OVO Charge app to see the miles you’ve used. The money you’ve
        saved will show up in your monthly bill as home EV charging credits.
      </P>
    </Margin>

    <StyledHeading3>Switching plans</StyledHeading3>
    <Margin bottom={6}>
      <P>
        Driving more or less than you expected? No problem, simply switch plans
        and your new allowance will kick in at the start of the next month.
      </P>
    </Margin>

    <StyledHeading3>Cancelling</StyledHeading3>
    <Margin bottom={6}>
      <P>
        You can cancel your plan any time. If you cancel all your perks will
        also be cancelled.
      </P>
    </Margin>
  </Margin>
);
